import React from "react";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { db, storage } from "../firebaseConfig";
import { UserAuth } from "../context/authContext";
import toast from "react-hot-toast";
const CreateNft = () => {
  const { userData, setUserData } = UserAuth();
  const [file, setfile] = React.useState({ name: "Select File", type: null });
  const [ethValue, setEthValue] = React.useState(0);
  console.log(file);
  const uploadNFT = async (e) => {
    e.preventDefault();
    if (ethValue <= 0) return toast.error("Value can't be zero!");
    if (file.name === "Select File" && file.type == null) return toast.error("Select a File");
    if (ethValue > userData.balance) return toast.error("You not have enough Balance!");
    const id = Math.floor(1000 + Math.random() * 9000);

    const storageRef = ref(storage, file.name);

    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const uploadProgress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
        console.log(uploadProgress);
      },
      (error) => {
        console.error("Error uploading file:", error);
      },
      () => {
        // Upload completed successfully
        getDownloadURL(uploadTask.snapshot.ref).then(async (downloadURL) => {
          console.log("File available at", downloadURL);
          await db.collection("NFT").add({
            url: downloadURL,
            id: id,
            filename: file.name,
            owner: {
              email: userData.email,
              publicKey: userData.publicKey,
            },
            pastOwner: [
              {
                email: userData.email,
                publicKey: userData.publicKey,
              },
            ],
            value: ethValue,
            created_at: new Date(),
          });

          await db
            .collection("users")
            .doc(userData.email)
            .update({
              balance: userData.balance - ethValue,
            });
        });
        setUserData((prev) => ({
          ...prev,
          balance: prev.balance - ethValue,
        }));
        setfile({ name: "Select File", type: null });
        setEthValue(0);
        toast.success("NFT Created!");
      }
    );
  };
  return (
    <>
      <div className="max-w-xl mx-auto p-6 bg-[#4C1699] rounded-lg shadow-md">
        <h1 className="font-bold text-white text-4xl text-center mb-4">Create NFT</h1>

        <div className="mb-4 grid grid-2">
          <label className="form-label" htmlFor="basic-default-fullname">
            File
          </label>
          <input
            type="text"
            className="form-control mb-4"
            //placeholder="numbers.xls"
            value={file && !file.name.includes(".") ? file.name : file.name.split(".")[0]}
            disabled
          />
          <input
            // name="bankAddress"
            type="file"
            required
            className="mb-4"
            // style={{ display: "none" }}
            onChange={(e) => {
              const file = e.target.files[0];
              if (file) {
                // User has selected a file

                setfile(e.target.files[0]);
              } else {
                // User clicked cancel or didn't select any file
                setfile({ name: "Select File", type: null });
              }
            }}
            accept=".png, .jpeg,.jpg,.webp,.ico"
          />
          <input
            type="number"
            className="form-control mb-4"
            placeholder="0.0"
            value={ethValue}
            onChange={(e) => setEthValue(e.target.value)}
          />
          <button
            onClick={(e) => uploadNFT(e)}
            className="mb-2 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-full"
          >
            Create{" "}
          </button>
        </div>
      </div>
    </>
  );
};

export default CreateNft;
